module.exports = __webpack_public_path__ + "static/stardust-card-centered-14a1938a98d0ee20cf09ccb483fb3179.png";